let apiAjax = false // Ajaxリクエスト
let apiAjaxResponse = '' // 最後のレスポンスを格納する

//   ####  ##      ##   ####  ##  ##
//  ##     ##      ##  ##     ## ##
//  ##     ##      ##  ##     ####
//  ##     ##      ##  ##     ## ##
//   ####  ######  ##   ####  ##  ##
/*
APIのURLにデータを送信する
<button type="btn" class="js-api" data-param="hoge=aaa&fuga=bbb&foo=ccc">
</button>
*/

window.addEventListener('click', (e) => {
  if (e.target.classList.contains('js-api')) {
    if (e.target.tagName !== 'LABEL') {
      e.preventDefault()
    }
    const item = e.target
    const param = item.dataset.param // パラメータ
    const jump = item.dataset.jump // 終了後の移動先

    window.apiAjax(param, jump)
  }
})

/*
         ########  #######  ########  ##     ##
         ##       ##     ## ##     ## #### ####
 ####### ######   ##     ## ########  ## ### ##
         ##       ##     ## ##   ##   ##     ##
         ##        #######  ##     ## ##     ##

フォーム送信して結果を反映する

<form action="hoge.php" method="POST" name="form-name">
  <button type="button" class="js-apiForm" data-form="form-name" data-input="type,item" data-require="" >
      更新
  </button>
</form>

*/

if (document.getElementsByClassName('js-apiForm')[0]) {
  window.addEventListener('click', (e) => {
    if (e.target.classList.contains('js-apiForm') && e.target.tagName === 'BUTTON') {
      e.preventDefault()
      apiForm(e.target)
    }
  })
}

function apiForm(item) {
  let param = '' // 送信パラメータ
  const name = item.dataset.form

  // 指定されているinputを取得して送信データ化する
  const inputList = item.dataset.input.split(',') // ,区切りで配列に変換

  for (let index = 0; index < inputList.length; index++) {
    if (index !== 0) {
      param += '&'
    }
    const input = inputList[index]
    const valueList = document.querySelectorAll('form[name="' + name + '"] [name="' + input + '"]')
    let value = ''

    for (const valueItem of valueList) {
      if ((valueItem.type === 'checkbox' || valueItem.type === 'radio') && !valueItem.checked) {
        continue
      }
      if (value !== '') {
        value += ',' // 配列系のデータはカンマ区切りにする
      }
      value += valueItem.value
    }

    param += input + '=' + encodeURIComponent(value)
    // console.log(param)
  }
  window.apiAjax(param, false)
}

/*
           ###    ########  ########  ##       ##    ##
         ##   ##  ##     ## ##     ## ##         ####
####### ##     ## ########  ########  ##          ##
        ######### ##        ##        ##          ##
        ##     ## ##        ##        ########    ##
*/
/**
 * Ajax処理を実行する
 * @param param {string} hoge=aaa&fuga=bbb&foo=ccc
 */
window.apiAjax = function (param, jump) {
  /* global apiUrl */
  let url = apiUrl
  const method = 'get'
  if (apiAjax) {
    // 既に通信中なら切断
    apiAjax.abort()
  }

  window.favCheck() // お気に入りチェック

  apiAjax = new XMLHttpRequest() // Ajaxリクエスト
  if (method === 'post') {
    apiAjax.open(method, url, true) // GET/POST, URL, 非同期処理
  } else {
    if (param) {
      url += (~url.indexOf('?') ? '&' : '?') + param // パラメータをURLに結合
    }

    // Ajaxと明示するパラメータを付ける
    url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'
    apiAjax.open(method, url, true) // GET/POST, URL, 非同期処理
  }
  apiAjax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
  // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
  // ajax.setRequestHeader('Pragma', 'no-cache')
  // ajax.setRequestHeader('Cache-Control', 'no-cache')
  // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
  if (method === 'post') {
    apiAjax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded') // POST時に必要なリクエストヘッダー
  }
  apiAjax.responseType = 'document' // 取得タイプ document text json
  apiAjax.timeout = 10000 // タイムアウト判定時間
  if (method === 'post') {
    apiAjax.send(param) // POSTリクエスト実行
  } else {
    apiAjax.send() // GETリクエスト実行
  }
  apiAjax.onload = function () {
    // アクセス成功
    if (apiAjax.status < 200 || apiAjax.status >= 400) {
      console.log('Error: Code ' + apiAjax.status) // エラー
      return
    }

    if (jump) {
      window.location.href = jump
    }
    window.favCheck() // お気に入りチェック
  }
  apiAjax.ontimeout = function (e) {
    // タイムアウト
  }
  apiAjax.onerror = function () {
    // 処理失敗
  }
  apiAjax.onloadend = function () {
    // 受信成否に関わらず実行
    apiAjax = false
  }
}
